import React from 'react'
import { SupplierRegistrationForm } from './styled'
import {
  Button,
  Modal,
  Input,
  Section,
  InputTextarea,
  Checkbox,
  SelectBox,
  InputUpload,
  Image,
  Table,
  Spinner,
  DatePickerInput,
  AttachedFile,
} from '../../components'
import { Redirect } from 'react-router-dom'
import {
  supplierRegisterController,
  mySupplierCompanyController,
  authController,
  jsonToFormData,
} from '../../apiService'
import { ICONS } from '../../themes'
import {
  STRING,
  ROUTE_PATH,
  toastFail,
  toastActive,
  validateEmail,
  localStorageService,
} from '../../helpers'
import { strWithCommas, numberRemoveCommas } from '../../helpers/number/commas'
import FileDownload from 'js-file-download'
import { store } from '../../store'
import { logout } from '../../store/actions'

export class SupplierRegistrationFormContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      supplierNation: 'domestic',
      mailKey: this.props.match.params.key || '',
      supplierInfo: {},
      supplierResponse: {},
      isShowLastCheckbox: true,
      isNeesSetupPassword: true,
      optionCurrency: [],
      optionsCountry: [],
      businessCategories: [],
      modals: [
        { name: 'edit', isOpen: false },
        { name: 'delete', isOpen: false },
        { name: 'add', isOpen: false },
      ],
      businessSubCategories: [],
      // optionBusinessType: [
      //   { id: 1, name: 'Manufacturer', checked: false },
      //   { id: 2, name: 'Distributor', checked: false },
      //   { id: 3, name: 'Dealer/Trader', checked: false },
      //   { id: 4, name: 'Service Provider', checked: false },
      // ],
      optionBusinessType: [],
      currency: [],
      isRedirect: false,
      selectedFile: [],
      passwordCorrect: '',
      confirmPasswordCorrect: '',
      infoCategory: [],
      indexCategory: 0,
      joinMainSupplier: false,

      errPasswordCorrect: '',
      errConfirmPasswordCorrect: '',
      errBranch: '',
      errRegisCapital: '',
      errRegisAddress: '',
      errContactAddress: '',
      errPhone: '',
      errEmail: '',
      errContactFullname: '',
      errContactPhone: '',
      errContactCountry: '',
      errRegisCountry: '',
      errServiceCategory: '',
      errYearEstablished: '',
      errOptionBusinessType: '',
      isLoading: false,
    }
  }
  componentDidMount = async () => {
    this.setState({ isLoading: true })
    this.verifyToken()
    // await this.fetchBusinessType()
    // await this.fetchBusinessCategories()
    // await this.fetchCurrency()
  }
  downloadAttachment = params => {
    if (params.id) {
      return mySupplierCompanyController()
        .downloadAttachmentRegistration(params.id)
        .then(res => FileDownload(res.data, params.name))
        .catch(error => {
          FileDownload(params.files, params.name)
        })
    } else {
      FileDownload(params.files, params.name)
    }
  }
  verifyToken = async () => {
    try {
      const key = this.state.mailKey
      if (!key) {
        return toastFail('Mailkey or supplier_id not found.')
      }

      // const res = await supplierRegisterController().verifyToken(key)
      const res = await authController().checkTokenExp(key)
      console.log('res', res)
      if (res && res.status === 'TokenValid') {
        this.fetchSuppierByID()
        this.fetchBusinessType()
        this.fetchBusinessCategories()
        this.fetchCurrency()
      } else {
        this.setState({ isRedirect: true })
      }
    } catch (error) {
      if (error.response && error.response.status) {
        if (error.response.status === 400) {
          this.setState({ isRedirect: true })
        }
      }
      throw error
    }
  }

  fetchSuppierByID = async () => {
    try {
      const key = this.state.mailKey

      const res = await supplierRegisterController().getSupplierInformation(key)
      if (res) {
        if (res.status === 'Already Account') {
          setTimeout(
            this.props.history.push(ROUTE_PATH.LINK_HAVE_ACCOUNT.LINK),
            500
          )
        } else {
          let supplierInfo = res

          supplierInfo.contact_country = {
            value: res.contact_country.id || 1,
            label: res.contact_country.name || 'Afghanistan',
          }

          if (
            res.regis_country &&
            res.regis_country.id &&
            res.regis_country.name
          ) {
            supplierInfo.regis_country = {
              value: res.regis_country.id,
              label: res.regis_country.name,
            }
          } else {
            supplierInfo.regis_country = {
              value: 1,
              label: 'Afghanistan',
            }
          }
          supplierInfo.year_established = supplierInfo.year_established
            ? supplierInfo.year_established
            : ''

          const supplierNation =
            res.contact_country.label === 'Thailand'
              ? 'domestic'
              : 'international'
          await this.fetchCountry(supplierNation)
          if (res.business_type.length > 0) {
            res.business_type.map(e => {
              if (e.business_type_name !== '') {
                var index = this.state.optionBusinessType.findIndex(
                  j => j.id === e.business_type_id
                )
                if (this.state.optionBusinessType.length > 0) {
                  this.state.optionBusinessType[index].checked = true
                }
              }
            })
          }

          this.setState({
            isLoading: false,
            supplierNation,
            supplierInfo,
            supplierResponse: res,
          })
          this.setDropdownCurrency(res.currency)
        }
      }
    } catch (error) {
      throw ('fetchSuppierByID fail', error)
    }
  }
  fetchBusinessCategories = async () => {
    try {
      const res = await supplierRegisterController().getBusinessCategories()
      if (res) {
        let categories = []
        res.map(e => {
          let options = {
            id: e.id,
            value: e.name,
            label: e.name,
          }
          categories.push(options)
        })
        this.setState({
          businessCategories: categories,
        })
      }
    } catch (error) {
      throw ('fetchBusinessCategories fail', error)
    }
  }
  fetchbusinessSubCategories = async id => {
    try {
      const res = await supplierRegisterController().getBusinessSubCategories(
        id
      )
      if (res) {
        let subCategories = []
        res.map(e => {
          let options = {
            id: e.id,
            value: e.name,
            checked: false,
          }
          subCategories.push(options)
        })
        this.setState({
          businessSubCategories: subCategories,
        })
      }
    } catch (error) {
      throw ('BusinessSubCategories fail', error)
    }
  }
  fetchbusinessSubCategoriesEdit = async event => {
    try {
      const res = await supplierRegisterController().getBusinessSubCategories(
        event.category_id
      )
      if (res) {
        let subCategories = []
        let options = {}
        res.map(e => {
          if (event.sub_category.find(j => j.name === e.name)) {
            options = {
              id: e.id,
              value: e.name,
              checked: true,
            }
          } else {
            options = {
              id: e.id,
              value: e.name,
              checked: false,
            }
          }
          subCategories.push(options)
        })
        this.setState({
          businessSubCategories: subCategories,
        })
      }
    } catch (error) {
      throw ('BusinessSubCategories fail', error)
    }
  }
  fetchBusinessType = async () => {
    try {
      const res = await supplierRegisterController().getBusinessType()
      if (res) {
        let businessType = []
        res.map(e => {
          let options = {
            id: e.id,
            value: e.name,
            checked: false,
          }
          businessType.push(options)
        })
        this.setState({
          optionBusinessType: businessType,
        })
      }
    } catch (error) {
      throw ('optionBusinessType fail', error)
    }
  }
  fetchCountry = async (supplierNation = '') => {
    try {
      const res = await supplierRegisterController().getCountry()
      if (res) {
        var country = []
        res.map(e => {
          return (country = [...country, { value: e.id, label: e.name }])
        })
        if (
          supplierNation === 'international' &&
          this.state.supplierInfo.company_type == 'Coporate'
        ) {
          const indexCountry = country.findIndex(e => {
            return e.label === 'Thailand'
          })
          country.splice(indexCountry, 1)
        }
        this.setState({
          optionsCountry: country,
        })
      }
    } catch (error) {
      throw ('fetchCountry fail', error)
    }
  }

  fetchCurrency = async () => {
    try {
      const res = await supplierRegisterController().getCurrency()
      if (res) {
        let currency = []
        res.map(e => {
          let options = {
            value: e.id,
            label: e.name,
          }
          currency.push(options)
        })
        this.setState({
          optionCurrency: currency,
        })
      }
    } catch (error) {
      throw ('Currency fail', error)
    }
  }

  setDropdownCurrency = (currency = {}) => {
    if (currency && currency.name && currency.id) {
      this.onChangeCurrency({
        label: currency.name,
        value: currency.id,
      })
    } else {
      this.onChangeCurrency({
        label: 'USD',
        value: 1,
      })
    }
  }

  validateFrom() {
    let isPass = true
    const { supplierInfo, confirmPasswordCorrect, passwordCorrect } = this.state
    let {
      isLoading,
      errPasswordCorrect,
      errConfirmPasswordCorrect,
      errBranch,
      errRegisCapital,
      errRegisAddress,
      errContactAddress,
      errPhone,
      errEmail,
      errContactFullname,
      errContactPhone,
      errContactCountry,
      errRegisCountry,
      errServiceCategory,
      errYearEstablished,
      errOptionBusinessType,
    } = this.state
    errYearEstablished = ''
    errConfirmPasswordCorrect = ''
    errPasswordCorrect = ''
    errBranch = ''
    errRegisCapital = ''
    errRegisAddress = ''
    errContactAddress = ''
    errPhone = ''
    errEmail = ''
    errContactFullname = ''
    errContactPhone = ''
    errContactCountry = ''
    errRegisCountry = ''
    errServiceCategory = ''
    errOptionBusinessType = ''
    // if (supplierInfo.branch === '') {
    //   isPass = false
    //   errBranch = 'This field is required'
    // }

    if (passwordCorrect === '') {
      isPass = false
      errPasswordCorrect = 'This field is required'
    } else if (passwordCorrect.length < 8) {
      isPass = false
      errPasswordCorrect = 'Minimum 8 characters'
    } else if (!/^(?=.*[A-Z])(?=.*\d)[A-Z\d]/.test(passwordCorrect)) {
      isPass = false
      errPasswordCorrect =
        'New Password should contain at least one upper case and one number character'
    }

    if (confirmPasswordCorrect === '') {
      isPass = false
      errConfirmPasswordCorrect = 'This field is required'
    } else if (confirmPasswordCorrect.length < 8) {
      isPass = false
      errConfirmPasswordCorrect = 'Minimum 8 characters'
    } else if (confirmPasswordCorrect !== passwordCorrect) {
      errConfirmPasswordCorrect = 'Password dose not match'
      isPass = false
    }

    if (supplierInfo.year_established === '') {
      isPass = false
      errYearEstablished = 'This field is required'
    }

    if (supplierInfo.regis_capital === '') {
      isPass = false
      errRegisCapital = 'This field is required'
    }

    if (supplierInfo.regis_address === '') {
      isPass = false
      errRegisAddress = 'This field is required'
    }

    if (supplierInfo.contact_address === '') {
      isPass = false
      errContactAddress = 'This field is required'
    }

    if (supplierInfo.phone === '') {
      isPass = false
      errPhone = 'This field is required'
    }

    if (supplierInfo.email === '') {
      isPass = false
      errEmail = 'This field is required'
    } else if (!validateEmail(supplierInfo.email)) {
      isPass = false
      errEmail = 'Email format invalid'
    }

    if (supplierInfo.contact_person.contact_person_full_name === '') {
      isPass = false
      errContactFullname = 'This field is required'
    }

    if (supplierInfo.contact_person.contact_person_phone === '') {
      isPass = false
      errContactPhone = 'This field is required'
    }
    if (supplierInfo.service_category.length === 0) {
      isPass = false
      errServiceCategory = 'This field is required'
      //toastFail('Business Group must not blank')
    }
    if (this.state.optionBusinessType) {
      const checked =
        this.state.optionBusinessType.filter(b => b.checked === true).length > 0
      if (!checked) {
        isPass = false
        errOptionBusinessType = 'This field is required'
      }
    }
    if (!isPass) {
      isLoading = false
    }
    this.setState(
      {
        errServiceCategory,
        errContactCountry,
        errRegisCountry,
        errPasswordCorrect,
        errConfirmPasswordCorrect,
        errBranch,
        errRegisCapital,
        errRegisAddress,
        errContactAddress,
        errPhone,
        errEmail,
        errContactFullname,
        errContactPhone,
        errYearEstablished,
        errOptionBusinessType,
        isLoading,
      },
      this.validateScrollTo
    )
    return isPass
  }

  validateFromIndividual() {
    let isPass = true
    const { supplierInfo, confirmPasswordCorrect, passwordCorrect } = this.state
    let {
      isLoading,
      errPasswordCorrect,
      errConfirmPasswordCorrect,
      errBranch,
      errRegisCapital,
      errRegisAddress,
      errContactAddress,
      errPhone,
      errEmail,
      errContactFullname,
      errContactPhone,
      errContactCountry,
      errRegisCountry,
      errServiceCategory,
      errYearEstablished,
      errOptionBusinessType,
    } = this.state
    errYearEstablished = ''
    errConfirmPasswordCorrect = ''
    errPasswordCorrect = ''
    errBranch = ''
    errRegisCapital = ''
    errRegisAddress = ''
    errContactAddress = ''
    errPhone = ''
    errEmail = ''
    errContactFullname = ''
    errContactPhone = ''
    errContactCountry = ''
    errRegisCountry = ''
    errServiceCategory = ''
    errOptionBusinessType = ''
    // if (supplierInfo.branch === '') {
    //   isPass = false
    //   errBranch = 'This field is required'
    // }

    if (passwordCorrect === '') {
      isPass = false
      errPasswordCorrect = 'This field is required'
    } else if (passwordCorrect.length < 8) {
      isPass = false
      errPasswordCorrect = 'Minimum 8 characters'
    }

    if (confirmPasswordCorrect === '') {
      isPass = false
      errConfirmPasswordCorrect = 'This field is required'
    } else if (confirmPasswordCorrect.length < 8) {
      isPass = false
      errConfirmPasswordCorrect = 'Minimum 8 characters'
    } else if (confirmPasswordCorrect !== passwordCorrect) {
      errConfirmPasswordCorrect = 'Password dose not match'
      isPass = false
    }

    // if (supplierInfo.year_established === '') {
    //   isPass = false
    //   errYearEstablished = 'This field is required'
    // }

    // if (supplierInfo.regis_capital === '') {
    //   isPass = false
    //   errRegisCapital = 'This field is required'
    // }

    if (supplierInfo.regis_address === '') {
      isPass = false
      errRegisAddress = 'This field is required'
    }

    if (supplierInfo.contact_address === '') {
      isPass = false
      errContactAddress = 'This field is required'
    }

    if (supplierInfo.phone === '') {
      isPass = false
      errPhone = 'This field is required'
    }

    if (supplierInfo.email === '') {
      isPass = false
      errEmail = 'This field is required'
    } else if (!validateEmail(supplierInfo.email)) {
      isPass = false
      errEmail = 'Email format invalid'
    }

    if (supplierInfo.contact_person.contact_person_full_name === '') {
      isPass = false
      errContactFullname = 'This field is required'
    }

    if (supplierInfo.contact_person.contact_person_phone === '') {
      isPass = false
      errContactPhone = 'This field is required'
    }
    if (supplierInfo.service_category.length === 0) {
      isPass = false
      errServiceCategory = 'This field is required'
      toastFail('Business Group must not blank')
    }
    if (this.state.optionBusinessType) {
      const checked =
        this.state.optionBusinessType.filter(b => b.checked === true).length > 0
      if (!checked) {
        isPass = false
        errOptionBusinessType = 'This field is required'
      }
    }
    if (!isPass) {
      isLoading = false
    }
    this.setState(
      {
        errServiceCategory,
        errContactCountry,
        errRegisCountry,
        errPasswordCorrect,
        errConfirmPasswordCorrect,
        errBranch,
        errRegisCapital,
        errRegisAddress,
        errContactAddress,
        errPhone,
        errEmail,
        errContactFullname,
        errContactPhone,
        errYearEstablished,
        errOptionBusinessType,
        isLoading,
      },
      this.validateScrollTo
    )
    return isPass
  }

  validateScrollTo() {
    const {
      errPasswordCorrect,
      errConfirmPasswordCorrect,
      errBranch,
      errRegisCapital,
      errRegisAddress,
      errContactAddress,
      errPhone,
      errEmail,
      errContactFullname,
      errContactPhone,
      errServiceCategory,
      errOptionBusinessType,
    } = this.state

    if (errPasswordCorrect) {
      window.scrollTo(0, 0)
    } else if (errConfirmPasswordCorrect) {
      window.scrollTo(0, 0)
    } else if (errBranch) {
      window.scrollTo(0, 100)
    } else if (errRegisCapital) {
      window.scrollTo(0, 150)
    } else if (errRegisAddress) {
      window.scrollTo(0, 500)
    } else if (errContactAddress) {
      window.scrollTo(0, 900)
    } else if (errPhone) {
      window.scrollTo(0, 1100)
    } else if (errEmail) {
      window.scrollTo(0, 1300)
    } else if (errServiceCategory) {
      window.scrollTo(0, 1800)
    } else if (errContactFullname) {
      window.scrollTo(0, 1800)
    } else if (errContactAddress) {
      window.scrollTo(0, 1800)
    } else if (errContactPhone) {
      window.scrollTo(0, 18800)
    } else if (errOptionBusinessType) {
      window.scrollTo(0, 1200)
    }
  }

  onJoinMainSupplier = () => {
    const joinMainSupplier = !this.state.joinMainSupplier
    this.setState({
      joinMainSupplier,
    })
  }

  save = async () => {
    try {
      const {
        supplierInfo,
        selectedFile,
        mailKey,
        passwordCorrect,
        optionBusinessType,
        joinMainSupplier,
      } = this.state
      if (
        (supplierInfo.company_type === 'Individual' &&
          this.validateFromIndividual()) ||
        this.validateFrom()
      ) {
        let params = supplierInfo
        // const DateNow = new Date()

        params.regis_country = supplierInfo.regis_country.value
          ? parseInt(supplierInfo.regis_country.value, 10)
          : null
        params.contact_country = supplierInfo.contact_country.value
          ? parseInt(supplierInfo.contact_country.value, 10)
          : null
        params.files = params.attachment
          ? params.attachment.map(at => at.files)
          : []
        params.mail_key = mailKey
        params.password = passwordCorrect
        params.join_main_supplier = joinMainSupplier
        params.contact_person = supplierInfo.contact_person
        params.invite_supplier = supplierInfo.invite_supplier
        params.currency = supplierInfo.currency.value
        params.regis_capital = numberRemoveCommas(supplierInfo.regis_capital)
        params.year_established = supplierInfo.year_established

        let business_type = []
        optionBusinessType.map(e => {
          if (e.checked === true) {
            business_type.push(e.id)
          }
        })
        params.business_type = business_type

        const paramsData = { ...params }
        Object.keys(paramsData).map(p => {
          if (
            p !== 'files' &&
            (paramsData[p] instanceof Object || paramsData[p] instanceof Array)
          ) {
            paramsData[p] = JSON.stringify(paramsData[p])
          }
        })
        // console.log('params')
        const res = await supplierRegisterController().updateSupplierInformation(
          paramsData
        )
        if (res) {
          if (res.status === 'UpdateSuccess') {
            this.gotoLogin()
            toastActive(res.message)
            document.body.classList.remove('modal-open')
          } else {
            toastFail(res.message)
            document.body.classList.remove('modal-open')
          }
        }

        this.setState({ isLoading: false })
      }
      // if (this.validateFrom()) {
      // }
      // else {
      //   if (supplierInfo.company_type)
      // }
    } catch (error) {
      this.setState({ isLoading: false })
      throw ('update suppiler fail', error)
    }
  }

  gotoLogin = () => {
    setTimeout(() => {
      this.props.history.push(ROUTE_PATH.LOGIN.LINK)
    }, 3000)
  }

  setInputArrayUploadFile = e => {
    let files = e.target.files
    if (files.length) {
      this.setState({
        selectedFile: [
          ...this.state.selectedFile,
          { files: e.target.files[0] },
        ],
      })
    } else {
      this.file = null
    }
  }

  toggleModal = evt => {
    this.setState(prevState => ({
      ...prevState,
      modals: prevState.modals.map(modal => ({
        ...modal,
        isOpen: modal.name === evt ? !modal.isOpen : false,
      })),
    }))
  }

  onClickAdd = () => {
    const infoCategory = []
    document.body.classList.add('modal-open')
    this.setState({ infoCategory }, this.toggleModal('add'))
  }

  onChangeBusinessGroup = async e => {
    let { infoCategory } = this.state
    infoCategory.category_option = e
    this.setState({ infoCategory }, await this.fetchbusinessSubCategories(e.id))
  }

  onChangeCurrency = e => {
    let { supplierInfo } = this.state
    supplierInfo.currency = e
    this.setState({ supplierInfo })
  }

  onChangeRegisCountry = e => {
    let { supplierInfo } = this.state
    supplierInfo.regis_country = e
    this.setState({ supplierInfo })
  }

  onChangeContactCountry = e => {
    let { supplierInfo } = this.state
    supplierInfo.contact_country = e
    this.setState({ supplierInfo })
  }

  onChangeSubCategory = (e, i) => {
    let { businessSubCategories } = this.state
    businessSubCategories[i].checked = !businessSubCategories[i].checked
    this.setState({ businessSubCategories })
  }

  validateCheckbox = () => {
    const { businessSubCategories } = this.state
    let notCheck = true
    businessSubCategories.map(e => {
      if (e.checked === true) {
        return (notCheck = false)
      }
    })

    return notCheck
  }

  onClickClose = () => {
    const infoCategory = []
    document.body.classList.remove('modal-open')
    this.setState({ infoCategory }, this.toggleModal())
  }

  onClickConfirm = () => {
    let { supplierInfo, infoCategory, businessSubCategories } = this.state
    let isPass = true
    if (supplierInfo.service_category.length > 0) {
      supplierInfo.service_category.map((e, i) => {
        if (e.category_id === infoCategory.category_option.id) {
          toastFail('Business Group is duplicate')
          return (isPass = false)
        }
      })
    }
    if (isPass) {
      let newCategory = {
        sub_category: [],
      }
      newCategory.category_id = infoCategory.category_option.id
      newCategory.category_name = infoCategory.category_option.value
      businessSubCategories.map(e => {
        const newSubCategory = {}
        if (e.checked === true) {
          newSubCategory.category_id = infoCategory.category_option.id
          newSubCategory.id = e.id
          newSubCategory.name = e.value
          newCategory.sub_category.push(newSubCategory)
        }
      })
      supplierInfo.service_category.push(newCategory)
      document.body.classList.remove('modal-open')
      this.toggleModal('add')
    }
  }

  onChangeBusinessType = (e, i) => {
    let { optionBusinessType } = this.state
    optionBusinessType[i].checked = !optionBusinessType[i].checked
    this.setState({ optionBusinessType })
  }

  onEditCategory = async (e, i) => {
    const infoCategory = e
    const indexCategory = i
    this.setState(
      { infoCategory, indexCategory },
      this.toggleModal('edit'),
      await this.fetchbusinessSubCategoriesEdit(e)
    )
  }

  onClickConfirmEdit = () => {
    let {
      supplierInfo,
      indexCategory,
      infoCategory,
      businessSubCategories,
    } = this.state
    let newCategory = {
      sub_category: [],
    }
    newCategory.category_id = infoCategory.category_id
    newCategory.category_name = infoCategory.category_name
    businessSubCategories.map(e => {
      const newSubCategory = {}
      if (e.checked === true) {
        newSubCategory.category_id = infoCategory.category_id
        newSubCategory.id = e.id
        newSubCategory.name = e.value
        newCategory.sub_category.push(newSubCategory)
      }
    })
    supplierInfo.service_category[indexCategory] = newCategory
    this.setState({ supplierInfo }, this.toggleModal('edit'))
  }

  onDeleteCategory = (e, i) => {
    const indexCategory = i
    const infoCategory = e
    this.setState({ indexCategory, infoCategory }, this.toggleModal('delete'))
  }

  onClickConfirmDelete = () => {
    let { supplierInfo, indexCategory } = this.state
    supplierInfo.service_category.splice(indexCategory, 1)
    this.toggleModal('delete')
  }

  onRegisCapitalChange = e => {
    if (e && e.target) {
      const { value } = e.target
      let numberCommas = ''
      numberCommas = numberRemoveCommas(value)
      const maxValue = '100000000000'
      if (numberCommas.length <= maxValue.length) {
        numberCommas = value
      } else {
        numberCommas = maxValue
      }

      this.setState({
        supplierInfo: {
          ...this.state.supplierInfo,
          regis_capital: numberCommas,
        },
      })
    }
  }

  render() {
    const {
      supplierInfo,
      supplierResponse,
      supplierNation,
      optionsCountry,
      optionCurrency,
      businessCategories,
      isShowLastCheckbox,
      isNeesSetupPassword,
      modals,
      isRedirect,
      optionBusinessType,
      passwordCorrect,
      confirmPasswordCorrect,
      infoCategory,
      businessSubCategories,
      errPasswordCorrect,
      errConfirmPasswordCorrect,
      errBranch,
      errRegisCapital,
      errRegisAddress,
      errContactAddress,
      errPhone,
      errEmail,
      errContactFullname,
      errContactPhone,
      errContactCountry,
      errRegisCountry,
      errServiceCategory,
      joinMainSupplier,
      isLoading,
    } = this.state

    return (
      <React.Fragment>
        {isRedirect ? (
          <Redirect push to={ROUTE_PATH.LINK_TOKEN_EXPIRED.LINK}></Redirect>
        ) : (
          <React.Fragment>
            <SupplierRegistrationForm>
              {isLoading && <Spinner className="loading" />}
              <Section className="main-content form">
                <Section className="content-body">
                  {isNeesSetupPassword && (
                    <React.Fragment>
                      <Section
                        mb={'2rem'}
                        className="setup-password-form-caption"
                      >
                        Account activation complete, please setup your password
                        and fill in necessary information.
                      </Section>

                      <Section mb={'3rem'} className="setup-password-form">
                        <Section
                          className={`form-group ${
                            errPasswordCorrect && 'is-error'
                          }`}
                        >
                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                id="reset_password"
                                label="Password"
                                name="password"
                                type="password"
                                isHorizontal={true}
                                value={passwordCorrect}
                                onChange={e => {
                                  this.setState({
                                    passwordCorrect: e.target.value,
                                  })
                                }}
                                minLength={8}
                                min={8}
                                placeholder="Minimum 8 characters"
                              />
                              <Section className="mix-number-text">
                                Use 8 or more characters with a mix of numbers
                                and at least one uppercase letter
                              </Section>
                            </Section>

                            <Section className="message is-password">
                              {errPasswordCorrect}
                            </Section>
                          </Section>
                        </Section>

                        <Section
                          className={`form-group ${
                            errConfirmPasswordCorrect && 'is-error'
                          }`}
                        >
                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                id="reenter_password"
                                isHorizontal={true}
                                label="Re-enter password"
                                name="confirmPassword"
                                type="password"
                                value={confirmPasswordCorrect}
                                onChange={e => {
                                  this.setState({
                                    confirmPasswordCorrect: e.target.value,
                                  })
                                }}
                                minLength={8}
                                min={8}
                                placeholder="Minimum 8 characters"
                              />
                            </Section>
                            <Section className="message is-password">
                              {errConfirmPasswordCorrect}
                            </Section>
                          </Section>
                        </Section>
                      </Section>
                    </React.Fragment>
                  )}

                  <Section mb={'3rem'} className="form-wrapper">
                    <Section className="form-group-title">
                      Company Information
                    </Section>

                    <Section className="form-group">
                      <label>Tax ID</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            name="tax_id"
                            disabled={true}
                            value={supplierInfo.tax_id}
                          />
                        </Section>
                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    <Section className="form-group">
                      <label>Company Name</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            disabled={true}
                            value={supplierInfo.company_name}
                          />
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>
                    {supplierInfo.company_type === 'Corporate' ? (
                      <React.Fragment>
                        <Section
                          className={`form-group ${errBranch && 'is-error'}`}
                        >
                          <label>Branch</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                type="text"
                                onChange={e => {
                                  supplierInfo.branch = e.target.value
                                  this.setState({
                                    supplierInfo,
                                  })
                                }}
                                value={supplierInfo.branch}
                                disabled={true}
                              />
                            </Section>
                            <Section className="message">{errBranch}</Section>
                          </Section>
                        </Section>

                        <Section
                          className={`form-group ${
                            this.state.errYearEstablished && 'is-error'
                          }`}
                        >
                          <label>Year Established</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <DatePickerInput
                                selected={
                                  supplierInfo.year_established === ''
                                    ? ''
                                    : supplierInfo.year_established
                                    ? new Date().setFullYear(
                                        supplierInfo.year_established
                                      )
                                    : new Date()
                                }
                                minDate={new Date('01-01-1000')}
                                maxDate={new Date()}
                                onChange={date => {
                                  supplierInfo.year_established = new Date(date)
                                    .getFullYear()
                                    .toString()
                                  this.setState({
                                    supplierInfo,
                                  })
                                }}
                                name="year_established"
                                showYearPicker
                                dateFormat="yyyy"
                                yearItemNumber={6}
                                disabled={
                                  supplierNation === 'domestic' &&
                                  supplierInfo.company_type == 'Corporate'
                                }
                              />
                            </Section>

                            <Section className="message">
                              {this.state.errYearEstablished}
                            </Section>
                          </Section>
                        </Section>

                        <Section
                          className={`form-group ${
                            errRegisCapital && 'is-error'
                          }`}
                        >
                          <label>Registered Capital</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              {supplierNation !== 'domestic' &&
                              supplierInfo.company_type == 'Corporate' ? (
                                <React.Fragment>
                                  <Input
                                    type="text"
                                    className="regis-capital"
                                    value={strWithCommas(
                                      supplierInfo.regis_capital
                                    )}
                                    onChange={e => {
                                      this.onRegisCapitalChange(e)
                                    }}
                                  />
                                  <SelectBox
                                    // id="active_status_filter"
                                    id="currency"
                                    className="option-currency"
                                    defaultValue={optionCurrency[0]}
                                    options={optionCurrency}
                                    value={supplierInfo.currency}
                                    isSearchable={false}
                                    isClearable={false}
                                    onChange={e => {
                                      this.onChangeCurrency(e)
                                    }}
                                  />
                                </React.Fragment>
                              ) : (
                                <Input
                                  type="text"
                                  value={
                                    Number(
                                      supplierInfo.regis_capital
                                    ).toLocaleString() + ' THB'
                                  }
                                  disabled={true}
                                />
                              )}
                            </Section>
                            <Section className="message">
                              {errRegisCapital}
                            </Section>
                          </Section>
                        </Section>
                      </React.Fragment>
                    ) : null}

                    <Section
                      className={`form-group ${errRegisAddress && 'is-error'}`}
                    >
                      <label className="regis-address">
                        Registered Address
                      </label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          {/* value 221 is Thailand */}
                          {supplierInfo.company_type === 'Corporate' &&
                          supplierInfo.regis_country.value === 221 ? (
                            <InputTextarea
                              value={supplierInfo.regis_address}
                              disabled={true}
                            />
                          ) : (
                            <InputTextarea
                              value={supplierInfo.regis_address}
                              onChange={e => {
                                supplierInfo.regis_address = e.target.value
                                this.setState({
                                  supplierInfo,
                                })
                              }}
                              // onBlur={handleBlur('contactAddress')}
                            />
                          )}
                        </Section>
                        <Section className="message">{errRegisAddress}</Section>
                      </Section>
                    </Section>

                    <Section
                      className={`form-group ${errRegisCountry && 'is-error'}`}
                    >
                      <label className="country">Country</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <SelectBox
                            // id="active_status_filter"
                            id="regis_country"
                            // defaultValue={optionsCountry[0]}
                            options={optionsCountry}
                            isSearchable={false}
                            isClearable={false}
                            isDisabled={true}
                            value={supplierInfo.regis_country}
                            onChange={e => {
                              this.onChangeRegisCountry(e)
                            }}
                          />
                        </Section>

                        <Section className="message">{errRegisCountry}</Section>
                      </Section>
                    </Section>

                    <Section
                      className={`form-group ${
                        errContactAddress && 'is-error'
                      }`}
                    >
                      <label className="contact-address">Contact Address</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <InputTextarea
                            value={supplierInfo.contact_address}
                            onChange={e => {
                              supplierInfo.contact_address = e.target.value
                              this.setState({
                                supplierInfo,
                              })
                            }}
                            // onBlur={handleBlur('contactAddress')}
                          />
                        </Section>
                        <Section className="message">
                          {errContactAddress}
                        </Section>
                      </Section>
                    </Section>
                    <Section
                      className={`form-group ${
                        errContactCountry && 'is-error'
                      }`}
                    >
                      <label className="country">Country</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <SelectBox
                            // id="active_status_filter"
                            id="contact_country"
                            defaultValue={optionsCountry[0]}
                            options={optionsCountry}
                            isSearchable={false}
                            isClearable={false}
                            value={supplierInfo.contact_country}
                            onChange={e => {
                              this.onChangeContactCountry(e)
                            }}
                          />
                        </Section>
                        <Section className="message">
                          {errContactCountry}
                        </Section>
                      </Section>
                    </Section>

                    <Section className={`form-group ${errPhone && 'is-error'}`}>
                      <label className="phone">Phone</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            value={supplierInfo.phone}
                            onChange={e => {
                              supplierInfo.phone = e.target.value
                              this.setState({
                                supplierInfo,
                              })
                            }}
                          />
                        </Section>
                        <Section className="message">{errPhone}</Section>
                      </Section>
                    </Section>

                    <Section className="form-group">
                      <label className="fax">
                        Fax <br /> (Optional)
                      </label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            value={supplierInfo.fax}
                            onChange={e => {
                              supplierInfo.fax = e.target.value
                              this.setState({
                                supplierInfo,
                              })
                            }}
                          />
                        </Section>
                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    <Section className={`form-group ${errEmail && 'is-error'}`}>
                      <label className="email">Email</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            value={supplierInfo.email}
                            onChange={e => {
                              supplierInfo.email = e.target.value
                              this.setState({
                                supplierInfo,
                              })
                            }}
                          />
                        </Section>
                        <Section className="message">{errEmail}</Section>
                      </Section>
                    </Section>

                    <Section className="form-group">
                      <label className="website">
                        Website <br /> (Optional)
                      </label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper">
                          <Input
                            type="text"
                            value={supplierInfo.website}
                            onChange={e => {
                              supplierInfo.website = e.target.value
                              this.setState({
                                supplierInfo,
                              })
                            }}
                          />
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>

                    <Section className="form-group">
                      <label className="tooltip-upload">
                        Attachment <br /> (Optional)
                        <Section className="link tooltip-attachment">
                          <Image
                            src={ICONS['icon-help.svg']}
                            alt="help"
                            tootipValue={`(*File type must be jpg, gif, png, bmp, tif, tiff, pdf, doc, docx, \n xls, xlsx, ppt, pptx, txt and Maximum File Size 50 Mb)`}
                            useTootipFor="FileType"
                            useTootip={true}
                          />
                        </Section>
                      </label>

                      <Section className="form-group-control ">
                        <Section className="form-group-inner-wrapper ">
                          <AttachedFile
                            maxFileSizeMb={50}
                            onSelect={(file, e, cb) => {
                              if (file instanceof File) {
                                if (!supplierInfo.attachment) {
                                  supplierInfo.attachment = [] // initialize if null/undefined
                                }
                                supplierInfo.attachment.push({
                                  name: file.name,
                                  supplier_company_id:
                                    supplierInfo.supplier_company_id,
                                  files: file,
                                })

                                this.setState({ supplierInfo }, cb)
                              }
                            }}
                          />
                        </Section>

                        {/* Should show when selected file */}
                        {!!supplierInfo.attachment &&
                          supplierInfo.attachment.map((e, i) => {
                            const fileValue = e
                            return (
                              <React.Fragment key={i}>
                                <Section className="attached-file-list">
                                  <a className="file-link removable">
                                    <a
                                      onClick={() => {
                                        this.downloadAttachment(fileValue)
                                      }}
                                    >
                                      <span className="file-name">
                                        {e.name}{' '}
                                      </span>
                                    </a>
                                    <Button
                                      className="link"
                                      onClick={() => {
                                        supplierInfo.attachment.splice(i, 1)
                                        this.forceUpdate()
                                      }}
                                    >
                                      <Image
                                        className="delete-circle-icon delete_company_profile"
                                        src={
                                          ICONS['icon-delete-circle-red.svg']
                                        }
                                        alt="delete circle"
                                      />
                                    </Button>
                                  </a>
                                </Section>
                              </React.Fragment>
                            )
                          })}

                        <Section className="message"></Section>
                      </Section>
                    </Section>
                  </Section>

                  {/* <Section className="form-group-header">Service</Section> */}
                  <Section mb={'3rem'} className="form-wrapper">
                    <Section className="form-group-title">Service</Section>

                    <Section
                      className={`form-group
                      ${this.state.errOptionBusinessType && 'is-error'}`}
                    >
                      <label>{STRING.BUSINESS_TYPE}:</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper checkbox">
                          {!!optionBusinessType &&
                            optionBusinessType.map((e, i) => (
                              <Checkbox
                                key={i}
                                id={i}
                                value={e.value}
                                checked={e.checked}
                                onChange={e => this.onChangeBusinessType(e, i)}
                              >
                                {e.value}
                              </Checkbox>
                            ))}
                        </Section>

                        <Section className="message"></Section>
                      </Section>
                    </Section>
                    <Section
                      className={`form-group ${
                        errServiceCategory && 'is-error'
                      }`}
                    >
                      <Section className="form-group service-category">
                        <label>Service Category:</label>

                        <Section className="form-group-control">
                          <Section className="form-group-inner-wrapper">
                            <Section>
                              <Button
                                className="theme-blue add"
                                onClick={() => this.onClickAdd()}
                              >
                                {/* <Image
                                  src={ICONS['icon-add-circular.svg']}
                                  alt="add icon"
                                /> */}
                                Add New
                              </Button>
                            </Section>
                            <Table className="service-category-table">
                              <Table.THEAD>
                                <Table.TR className="header">
                                  <Table.TD className="business-group">
                                    Business Group
                                  </Table.TD>

                                  <Table.TD className="service-product">
                                    Service & Product
                                  </Table.TD>
                                  <Table.TD></Table.TD>
                                </Table.TR>
                              </Table.THEAD>
                              {!!supplierInfo.service_category &&
                                supplierInfo.service_category.map((e, i) => (
                                  <React.Fragment key={i}>
                                    <Table.TBODY>
                                      <Table.TR>
                                        <Table.TD className="business-group">
                                          {e.category_name}
                                        </Table.TD>
                                        <Table.TD className="service-product">
                                          {e.sub_category.map((j, index) => {
                                            return (
                                              <React.Fragment key={index}>
                                                {j.name}
                                                <br />
                                              </React.Fragment>
                                            )
                                          })}
                                        </Table.TD>
                                        <Table.TD>
                                          <Section>
                                            <Button
                                              className="theme-blue edit"
                                              onClick={() => {
                                                this.onEditCategory(e, i)
                                              }}
                                            >
                                              Edit
                                            </Button>
                                            <Button
                                              className="theme-red delete"
                                              onClick={() => {
                                                this.onDeleteCategory(e, i)
                                              }}
                                            >
                                              Delete
                                            </Button>
                                          </Section>
                                        </Table.TD>
                                      </Table.TR>
                                    </Table.TBODY>
                                  </React.Fragment>
                                ))}
                            </Table>
                          </Section>

                          <Section className="message"></Section>
                        </Section>
                      </Section>
                    </Section>
                  </Section>

                  <Section className="form-wrapper">
                    {!!supplierInfo.contact_person && (
                      <React.Fragment>
                        <Section className="form-group-title">
                          Contact Person
                        </Section>
                        {/* <Section className="form-group-header">
                          Contact Person
                        </Section> */}
                        <Section
                          className={`form-group ${
                            errContactFullname && 'is-error'
                          }`}
                        >
                          <label>Full name</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                type="text"
                                value={
                                  supplierInfo.contact_person
                                    .contact_person_full_name
                                }
                                onChange={e => {
                                  supplierInfo.contact_person.contact_person_full_name =
                                    e.target.value
                                  this.setState({
                                    supplierInfo,
                                  })
                                }}
                              />
                            </Section>
                            <Section className="message">
                              {errContactFullname}
                            </Section>
                          </Section>
                        </Section>
                        <Section className="form-group">
                          <label>Email</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                type="text"
                                value={
                                  supplierInfo.contact_person
                                    .contact_person_mail
                                }
                                disabled={true}
                              />
                            </Section>

                            <Section className="message"></Section>
                          </Section>
                        </Section>
                        <Section
                          className={`form-group ${
                            errContactPhone && 'is-error'
                          }`}
                        >
                          <label>Phone</label>

                          <Section className="form-group-control">
                            <Section className="form-group-inner-wrapper">
                              <Input
                                type="text"
                                value={
                                  supplierInfo.contact_person
                                    .contact_person_phone
                                }
                                onChange={e => {
                                  supplierInfo.contact_person.contact_person_phone =
                                    e.target.value
                                  this.setState({
                                    supplierInfo,
                                  })
                                }}
                              />
                            </Section>
                            <Section className="message">
                              {errContactPhone}
                            </Section>
                          </Section>
                        </Section>
                      </React.Fragment>
                    )}
                  </Section>

                  <Section className="form-actions">
                    {/* <Button className="theme-border-gray">Cancel</Button> */}

                    <Button
                      className="theme-green"
                      onClick={() => {
                        this.setState({ isLoading: true }, this.save)
                      }}
                    >
                      Confirm
                    </Button>
                  </Section>
                </Section>
              </Section>
            </SupplierRegistrationForm>

            {/*Modal Edit*/}
            <Modal
              id="edit"
              className="supplier-registration buyer edit theme-blue"
              isOpen={
                modals
                  .filter(modal => {
                    return modal.name === 'edit'
                  })
                  .map(obj => obj.isOpen)[0]
              }
            >
              <Modal.Header>Edit Service Category</Modal.Header>

              <Modal.Body>
                <Section className="form-wrapper">
                  <Section className="form-group">
                    <label>Business Group</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <Input
                          type="text"
                          name="energy"
                          value={infoCategory.category_name || null}
                          disabled
                        />
                      </Section>
                    </Section>
                  </Section>

                  <Section className="form-group">
                    <label className="label">Service & Product</label>

                    <Section className="form-group-control">
                      <Section className="checkbox-list flex-wrap">
                        {!!businessSubCategories &&
                          businessSubCategories.map((e, i) => (
                            <Checkbox
                              key={i}
                              id={e.value}
                              value={e.value}
                              checked={e.checked}
                              onChange={e => this.onChangeSubCategory(e, i)}
                            >
                              {e.value}
                            </Checkbox>
                          ))}
                      </Section>
                    </Section>
                  </Section>
                </Section>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  id=""
                  className="theme-border-gray close"
                  onClick={() => {
                    this.onClickClose()
                  }}
                >
                  Cancel
                </Button>

                <Button
                  id=""
                  className="theme-green save"
                  onClick={() => {
                    this.validateCheckbox() ? {} : this.onClickConfirmEdit()
                  }}
                  disabled={this.validateCheckbox()}
                >
                  Ok
                </Button>
              </Modal.Footer>
            </Modal>

            {/*Modal Delete*/}
            <Modal
              id="delete"
              className="theme-blue"
              isOpen={
                modals
                  .filter(modal => {
                    return modal.name === 'delete'
                  })
                  .map(obj => obj.isOpen)[0]
              }
              modalWidth="575px"
            >
              <Modal.Header>Delete</Modal.Header>

              <Modal.Body>
                <p className="default text-center">
                  Are you sure to delete? <br />
                  {infoCategory.category_name || null}
                </p>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  id=""
                  className="theme-border-gray"
                  onClick={() => {
                    this.toggleModal('delete')
                  }}
                >
                  Cancel
                </Button>

                <Button
                  id=""
                  className="theme-green"
                  onClick={() => {
                    this.onClickConfirmDelete()
                  }}
                >
                  Confirm
                </Button>
              </Modal.Footer>
            </Modal>

            {/*Modal Add New*/}
            <Modal
              id="add"
              className="supplier-registration buyer add theme-blue"
              isOpen={
                modals
                  .filter(modal => {
                    return modal.name === 'add'
                  })
                  .map(obj => obj.isOpen)[0]
              }
            >
              <Modal.Header>Add Service Category</Modal.Header>

              <Modal.Body>
                <Section className="form-wrapper">
                  <Section className="form-group select-template">
                    <label>Business Group</label>

                    <Section className="form-group-control">
                      <Section className="form-group-inner-wrapper">
                        <SelectBox
                          placeholder="Select Business Group"
                          className="select-template"
                          value={infoCategory.category_option || null}
                          options={businessCategories}
                          onChange={e => {
                            this.onChangeBusinessGroup(e)
                          }}
                        />
                      </Section>
                    </Section>
                  </Section>
                  {infoCategory.category_option && (
                    <Section className="form-group">
                      <label className="label">Service & Product</label>

                      <Section className="form-group-control">
                        <Section className="form-group-inner-wrapper checkbox">
                          {!!businessSubCategories &&
                            businessSubCategories.map((e, i) => (
                              <Checkbox
                                key={i}
                                id={e.value}
                                value={e.value}
                                checked={e.checked}
                                onChange={e => this.onChangeSubCategory(e, i)}
                              >
                                {e.value}
                              </Checkbox>
                            ))}
                        </Section>
                      </Section>
                    </Section>
                  )}
                </Section>
              </Modal.Body>

              <Modal.Footer>
                <Button
                  id=""
                  className="theme-border-gray close"
                  onClick={() => {
                    this.onClickClose()
                  }}
                >
                  Cancel
                </Button>

                <Button
                  id=""
                  className="theme-green save"
                  onClick={() => {
                    this.validateCheckbox() ? {} : this.onClickConfirm()
                  }}
                  disabled={this.validateCheckbox()}
                >
                  Ok
                </Button>
              </Modal.Footer>
            </Modal>
          </React.Fragment>
        )}
      </React.Fragment>
    )
  }
}
